module.exports = __webpack_public_path__ + "img/star-filled.f60f9272.svg";